import { createContext, useContext } from 'react'
import { useInteractions } from '@floating-ui/react'

interface ContextInterface {
  activeIndex: number | null
  selectedIndex: number | null
  getItemProps: ReturnType<typeof useInteractions>['getItemProps']
  handleSelect: (index: number | null) => void
}

const SelectContext = createContext<Partial<ContextInterface>>(
  {} as ContextInterface,
)

const SelectProvider = SelectContext.Provider
const useSelect = () => useContext(SelectContext)

export { useSelect, SelectProvider, SelectContext }
